import { NgModule, ComponentFactoryResolver } from '@angular/core';

import { AppComponent } from './app.component';
import { registerLocaleData, LocationStrategy, HashLocationStrategy, DatePipe, PathLocationStrategy } from '@angular/common';
import tr from '@angular/common/locales/tr';
import { AuthenticationModule } from './layouts/authentication/authentication.module';
import { SchoolModule } from './layouts/school/school.module';
//import { AdministrationModule } from './layouts/administration/administration.module';
import { SlugifyPipe } from './shared/pipes/slugify.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { RouteStateService } from './core/services/route-state.service';
import { BootstrapModule } from './shared/shared-bootstrap.module';
import { SharedGlobalModule } from './shared/shared-global.module';
import { SharedComponentsModule } from './shared/shared-components.module';
import { trLocale } from 'ngx-bootstrap/locale';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { ConferenceModule } from './layouts/conference/conference.module';
import { ExamModule } from './layouts/exam/exam.module';
import { FormsModule } from '@angular/forms';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { NgxImageCompressService } from 'ngx-image-compress';
import { PrintModule } from './layouts/print/print.module';

registerLocaleData(tr);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    DigitOnlyModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot([]),
    BootstrapModule,
    SharedGlobalModule,
    AuthenticationModule,
    SharedComponentsModule,
    ConferenceModule,
    ExamModule,
    SchoolModule,
    FormsModule,
    PrintModule
  ],
  providers: [
    RouteStateService,
    SlugifyPipe,
    DatePipe,
    NgxImageCompressService,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
